import type { PublicEvent } from "../types/public";

function norm(s: string): string {
  return s.replace(/\s+/g, " ").trim().toLowerCase();
}

/** 会場文字列から「○○駅」を拾う */
function stationsIn(venue: string): string[] {
  const out: string[] = [];
  const re = /([^，,\s]+駅)/g;
  let m: RegExpExecArray | null;
  while ((m = re.exec(venue))) out.push(m[1]!);
  return out;
}

/**
 * 同一開催日のなかで「近い」イベントを返す。
 * 会場一致・都道府県一致・駅名一致・会場の部分一致（短すぎる一致は除外）でスコア化。
 */
export function nearbyPublicEvents(center: PublicEvent, pool: PublicEvent[], max = 8): PublicEvent[] {
  const id = center.id;
  const d = String(center.event_date ?? "").slice(0, 10);
  if (!d) return [];
  const v = norm(String(center.venue ?? ""));
  const p = norm(String(center.prefecture ?? ""));
  const centerStations = stationsIn(String(center.venue ?? ""));

  const scored = pool
    .filter((e) => e.id !== id && String(e.event_date ?? "").slice(0, 10) === d)
    .map((e) => {
      let score = 0;
      const ev = norm(String(e.venue ?? ""));
      const ep = norm(String(e.prefecture ?? ""));
      if (v && ev && v === ev) score += 100;
      if (p && ep && p === ep) score += 45;
      if (v && ev && Math.min(v.length, ev.length) >= 4 && (ev.includes(v) || v.includes(ev))) score += 30;
      const est = stationsIn(String(e.venue ?? ""));
      for (const s of centerStations) {
        if (est.includes(s)) score += 55;
      }
      return { e, score };
    })
    .filter((x) => x.score >= 30)
    .sort((a, b) => b.score - a.score);

  const out: PublicEvent[] = [];
  const seen = new Set<string>();
  for (const { e } of scored) {
    if (seen.has(e.id)) continue;
    seen.add(e.id);
    out.push(e);
    if (out.length >= max) break;
  }
  return out;
}
